import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hqgl",
  "use": "icon-hqgl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hqgl\"><defs><style type=\"text/css\"></style></defs><path d=\"M133.999 934.463V347.79H894v586.48L512.165 781.49 133.999 934.463z m378.035-221.957L830 839.729V411.79H197.999v427.747l314.035-127.031zM132.056 241.676h764.118v64H132.056zM128.025 108.999h768.149v84H128.025z\" fill=\"\" p-id=\"2539\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol